import { filter, mergeMap } from 'rxjs/operators';

import { RootEpic } from '../../../store/epics';
import { ErrorType } from '../../../store/reducers/common';
import {
  notifyBankAccountConnected,
  notifyBankAccountConnectedFail,
  notifyBankAccountConnectedSuccess,
} from '../reducers/bank-account-linking.reducer';

const notifyBankAccountConnectedEpic: RootEpic = (action$, _state$, { api }) => {
  return action$.pipe(
    filter(notifyBankAccountConnected.match),
    mergeMap(({ payload: { event, onSuccess: success } }) =>
      api.bankAccountLinking
        .notifyBankAccountConnected(event)
        .then(() => [notifyBankAccountConnectedSuccess(), success])
        .catch((error: ErrorType) => [notifyBankAccountConnectedFail(error)]),
    ),
    mergeMap((actions) => actions),
  );
};

export { notifyBankAccountConnectedEpic };
